import PxoDescargaTable             from './PxoDescargaTable'
import api                          from '../../../../services/api'

import { useEffect, useState }      from 'react'

import { usePxoPage }               from "../../../../contexts/PxoPageContext"
import PxoLoadingTable                    from '../PxoLoadingTable'
//import { JsonViewer } from 'view-json-react';
const PxoDescargaTableContainer = ({segment}) => {

    const { selectedDate, selectedHorizonTypeId, setNotFoundTables, setPxoId, updateDescargaTable } = usePxoPage()

    const [ _pxoDescargaTableData,       _setPxoDescargaTableData        ] = useState(null)
    const [ _pxoDescargaTableMedianData, _setPxoDescargaTableMedianData  ] = useState(null)
    
    const [ _isLoading, _setIsLoading ] = useState(true)

    const [ tryFecthAgain, setTryFetchAgain ] = useState(false)


    const fetchPxoDescargaTable = async () => {
        
        _setIsLoading(true)   
        setNotFoundTables(false) 
        
        try {

            if (!selectedDate || !selectedHorizonTypeId) return
            
            const response = await api.get(`/getPxoDescargaTable`, {
                params: {
                    selectedDate,
                    pxoHorizonId: selectedHorizonTypeId,
                    segment
                },
                timeout: 30000 
            })

            const { pxoDescargaTable, pxoDescargaTableMedian } = response.data

            const { id } = pxoDescargaTable.ownerPxo

            setPxoId(id)
            _setPxoDescargaTableData(pxoDescargaTable)
            _setPxoDescargaTableMedianData(pxoDescargaTableMedian)

        } catch (error) {
            
            _setPxoDescargaTableData(null)
            _setPxoDescargaTableMedianData(null)
            setNotFoundTables(true) 
            setPxoId(null)
            
            if (error.response?.status !== 404 && error.response?.status !== 400) console.log(error)

        }

        _setIsLoading(false)
    
    }

    useEffect(() => {

        setNotFoundTables(false)
        fetchPxoDescargaTable()

    }, [selectedDate, selectedHorizonTypeId, tryFecthAgain, updateDescargaTable])

    return (

    <div className='text-center w-fit flex flex-col gap-2'>

        <h2>Descarga Total (vgs)</h2>

        <div className='flex flex-row gap-4'>
            
            {_isLoading ? (
                <>
                    <PxoLoadingTable
                        rows={segment == "granel" ? 20 : 12}
                        cols={5}
                        headerColor="bg-[#004B9B]"
                    />

                    
                    <PxoLoadingTable
                        rows={segment == "granel" ? 20 : 12}
                        cols={1}
                        headerColor="bg-[#004B9B]"
                    />

                   
                </>
            ) : _pxoDescargaTableData && _pxoDescargaTableMedianData ? (
                <>

                    <PxoDescargaTable
                        allowNames={false}
                        tableData={_pxoDescargaTableData}
                    />

                    {/* <div style={{ width: "100%", maxWidth: "1200px", backgroundColor: "#2d2d2d", alignItems: 'left' }}>
                        <JsonViewer data={_pxoDescargaTableData} theme="dark" />
                    </div>  */}

                    <PxoDescargaTable
                        allowNames={false}
                        tableData={_pxoDescargaTableMedianData}
                    />

                </>
            ) : (

                <div 
                    className="
                        w-full
                        text-center
                        bg-gray-100
                        h-full
                        p-2.5
                        border
                        border-gray-300
                        rounded
                        cursor-pointer
                        hover:bg-gray-200
                        transition
                    "
                    onClick={() => setTryFetchAgain(!tryFecthAgain)}
                >
                    Nenhuma informação encontrada.
                    <p className='text-[10px]'>(clique para tentar novamente)</p>
                </div>
            )}
        </div>

    </div>
)}

export default PxoDescargaTableContainer